import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { IoReload } from "react-icons/io5";
import { BsPencil } from "../../../assets/icons/vander";
import { useProcedureRoomsStore } from "../../../hooks";
import {
  SelectForm,
  LoadingData,
  ErrorMessage,
  SuccessMessage,
} from "../../ui";
import { paginationOptions } from "../../data";
import { ModalEditProcedureRoom } from "./";

export const ProcedureRoomsTable = () => {
  // Datos del hook ----------------------------------------//
  const {
    // Props
    isLoadingData,
    procedureRooms,
    message,
    pageSize,
    page,
    totalPages,

    // Methods
    startGetProcedureRooms,
    startChangePageSize,
    startChangePage,
    startAddPage,
    startRemovePage,
    reloadProcedureRooms,
  } = useProcedureRoomsStore();

  // States ------------------------------------------------//
  const [editProcedureRoom, setEditProcedureRoom] = useState(false);
  const [procedureRoom, setProcedureRoom] = useState(null);

  // Formulario --------------------------------------------//
  // Funciones ---------------------------------------------//
  const onChangePageSize = ({ target }) => {
    startChangePageSize(target.value);
  };

  const onChangePage = (page) => {
    startChangePage(page);
  };

  // Efectos -----------------------------------------------//
  useEffect(() => {
    if (procedureRooms.length === 0) {
      startGetProcedureRooms(page, pageSize);
    }
  }, [procedureRooms.length, startGetProcedureRooms, page, pageSize]);

  useEffect(() => {
    if (!editProcedureRoom) {
      setProcedureRoom(null);
    }
  }, [editProcedureRoom]);

  return (
    <>
      <div className="row text-center mb-4">
        <div className="col-12 mt-4">
          <div className="d-md-flex align-items-end text-center justify-content-between">
            <SelectForm
              label={`Registros por página`}
              options={paginationOptions}
              labelKey={"description"}
              name={`pageSize`}
              value={pageSize}
              onInputChange={onChangePageSize}
            />

            <ul className="pagination justify-content-center mb-0 mt-3 mt-sm-0">
              <Link
                to="#"
                className="btn btn-icon btn-pills btn-soft-primary me-4"
                onClick={() => {
                  reloadProcedureRooms();
                }}
              >
                <IoReload />
              </Link>
              <li className="page-item" onClick={() => startRemovePage()}>
                <Link className="page-link" to="#" aria-label="Previous">
                  &lt;
                </Link>
              </li>
              {Array.from({ length: totalPages }, (_, index) => (
                <li
                  key={index}
                  className={`page-item ${
                    parseInt(page) === index + 1 ? "active" : ""
                  }`}
                  onClick={() => onChangePage((index + 1).toString())}
                >
                  <Link className={`page-link`} to="#">
                    {index + 1}
                  </Link>
                </li>
              ))}
              <li className="page-item" onClick={() => startAddPage()}>
                <Link className="page-link" to="#" aria-label="Next">
                  &gt;
                </Link>
              </li>
            </ul>
          </div>
        </div>
      </div>

      {isLoadingData && <LoadingData className="mb-4" />}
      {message?.type === "errorProcedureRooms" && (
        <ErrorMessage className="mb-4">{message.text}</ErrorMessage>
      )}
      {message?.type === "success" && (
        <SuccessMessage className="mb-4">{message.text}</SuccessMessage>
      )}

      <div
        className="table-responsive shadow rounded"
        style={{ fontFamily: "Inter, sans-serif" }}
      >
        <table className="table table-center bg-white mb-0">
          <thead>
            <tr>
              <th className="border-bottom p-3" style={{ minWidth: "50px" }}>
                #
              </th>
              <th className="border-bottom p-3">Nombre</th>
              <th className="border-bottom p-3">Número</th>
              <th className="border-bottom p-3">Letra</th>
              <th className="border-bottom p-3">Sede</th>
              <th className="border-bottom p-3">Ips</th>
              <th
                className="border-bottom p-3"
                style={{ minWidth: "100px" }}
              ></th>
            </tr>
          </thead>
          <tbody>
            {procedureRooms.map((procedureRoom, index) => (
              <tr key={procedureRoom.id}>
                <th className="p-3">{index + 1}</th>
                <td className="p-3">{procedureRoom.name}</td>
                <td className="p-3">{procedureRoom.number}</td>
                <td className="p-3">{procedureRoom.letter}</td>
                <td className="p-3">{procedureRoom.headquarterName}</td>
                <td className="p-3">{procedureRoom.ipsName}</td>
                <td className="text-end p-3">
                  <button
                    style={{ width: "24px" }}
                    className="btn btn-icon fs-lg text-gray-300"
                    onClick={() => {
                      setEditProcedureRoom(true);
                      setProcedureRoom(procedureRoom);
                    }}
                  >
                    <BsPencil />
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <ModalEditProcedureRoom
        editProcedureRoom={editProcedureRoom}
        setEditProcedureRoom={setEditProcedureRoom}
        procedureRoom={procedureRoom}
      />
    </>
  );
};
